// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"505":"d314d004","748":"d314d004"}[chunkId] + ".chunk.css";
};